/**
 * Account Management Service
 * Handles account deletion and cleanup
 */

const DELETE_ACCOUNT_URL = process.env.REACT_APP_DELETE_ACCOUNT_URL || '';

/**
 * Delete all user data and account
 * Calls backend which handles: blob storage, Stripe, and Azure CIAM deletion
 */
export async function deleteUserAccount(userId: string): Promise<void> {
  if (!userId) throw new Error('User ID is required');

  if (!DELETE_ACCOUNT_URL) throw new Error('Delete account URL not configured');

  const response = await fetch(
    `${DELETE_ACCOUNT_URL}&userId=${encodeURIComponent(userId)}`,
    { method: 'DELETE' }
  );

  const data = await response.json();

  if (!response.ok && response.status !== 207) {
    throw new Error(data.error || 'Failed to delete account');
  }

  if (data.errors?.length) {
    console.warn('Account deletion partial errors:', data.errors);
  }

  clearUserLocalStorage(userId);

  console.log(`Account deletion complete for user: ${userId}`, data.results);
}

/**
 * Clear all user data from localStorage
 */
function clearUserLocalStorage(userId: string): void {
  localStorage.removeItem(`favorites_${userId}`);
  localStorage.removeItem('recentUploads');
  localStorage.removeItem(`fileTags_${userId}`);

  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes(userId)) keysToRemove.push(key);
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
}

/**
 * Get account deletion confirmation text
 */
export function getDeleteAccountWarning(fileCount: number, storageSize: string): string {
  return `
⚠️ WARNING: This action is immediate and cannot be undone!

The following will happen right away:
• ${fileCount} files (${storageSize}) will be permanently deleted
• Your subscription will be cancelled immediately
• Your account will be removed
• You will not be charged further

Please download any files you need BEFORE proceeding.
  `.trim();
}
